import { Button, evaluate, Typography, useMediaQuery } from "@kyan/ui";
import { useState } from "react";

import { useTradingSession } from "#/services/kyan/hooks/useTradingSession";
import { useShowOneClickTradingModal } from "#/store/app/portfolio/settings/showOneClickTradingModal";

import { TradeOption } from "./components/TradeOption/TradeOption";

export const OneClickTradingModalContent: React.FC = () => {
  const { isSm } = useMediaQuery();
  const { setShowOneClickTradingModal } = useShowOneClickTradingModal();
  const {
    createSession,
    isCreatingSession,
    deleteSession,
    isDeletingSession,
    isTradingSessionEnabled,
  } = useTradingSession();
  const [isEnabled, setIsEnabled] = useState(Boolean(isTradingSessionEnabled));

  const hasChanges = isEnabled !== isTradingSessionEnabled;

  const buttonLabel = evaluate({
    Done: !hasChanges,
    "Enable One-Click Trading": isEnabled,
    "Disable One-Click Trading": !isEnabled,
  });

  const handleSubmit = () => {
    if (isEnabled === isTradingSessionEnabled) {
      setShowOneClickTradingModal(false);
      return;
    }
    if (!isEnabled) {
      deleteSession();
      return;
    }
    createSession();
  };

  return (
    <div className="w-full max-w-110">
      {isSm && (
        <Typography
          element="h2"
          font="grotesk"
          weight="medium"
          variant="primary"
        >
          Trading Mode
        </Typography>
      )}
      <div className="my-6 flex flex-col gap-4">
        <TradeOption
          checked={isEnabled}
          title="One-Click Trading"
          badge={isTradingSessionEnabled ? "Enabled" : "Recommended"}
          description={
            <>
              Trade seamlessly without signing each order individually. For
              trading only.
              <br />
              <br />
              Sign once to start your session for smooth, uninterrupted trading.
              <br />
              <br />
              This will create an API Key to be used on this device.
            </>
          }
          onClick={() => {
            setIsEnabled(true);
          }}
        />
        <TradeOption
          checked={!isEnabled}
          title="Sign Every Transaction"
          description="Manually approve each trade with your wallet."
          onClick={() => {
            setIsEnabled(false);
          }}
        />
      </div>

      <Button
        size="lg"
        className="mt-2 w-full"
        isLoading={isCreatingSession || isDeletingSession}
        onClick={handleSubmit}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};
